
	import Vue from "vue";

	import helpers from "../inc/helpers";
	import api from "../api";

	import TaxRate from "../data/TaxRate";
	import HomesteadSavings from "../data/HomesteadSavings";

	export default Vue.extend({
		data() {
			return {
				isLoading: true,
				isSearching: false,
				selectedTaxDistrict: null as null | TaxRate,
				taxDistricts: [] as Array<TaxRate>,
				result: null as null | HomesteadSavings,
				error: null as null | string,
			};
		},

		mounted() {
			api.getTaxRates().then((taxRates: Array<TaxRate>) => {
				this.taxDistricts = taxRates;
				this.isLoading = false;
			});
		},

		methods: {
			clearForm() {
				this.resetForm();
			},

			resetForm() {
				this.result = null;
				this.error = null;
			},
		},

		computed: {
			sortedTaxRates(): Array<TaxRate> {
				return this.taxDistricts.sort((a: TaxRate, b: TaxRate) => parseInt(a.gca_tax_rate_district_number) - parseInt(b.gca_tax_rate_district_number));
			},
		},

		filters: {
			formatCurrency(val: string) {
				return helpers.formatCurrency(val, false);
			},

			formatTaxDistrictNumber(number: number): string {
				return number.toString();
			},
		},

		watch: {
			selectedTaxDistrict(to: TaxRate) {
				this.isSearching = true;

				api.getHomesteadSavings(parseInt(to.gca_tax_rate_district_number)).then((homesteadSavings: HomesteadSavings) => {
					this.result = homesteadSavings;
					this.isSearching = false;
				});
			},
		},
	});
